// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2UPOA","itemTitle":"ClientEmergencyInfo_itemTitle__EjHOV","itemText":"ClientEmergencyInfo_itemText__2txGD"};